var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveThumsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 18.3333V9.16663M1.6665 10.8333V16.6666C1.6665 17.5871 2.4127 18.3333 3.33317 18.3333H14.5217C15.7556 18.3333 16.805 17.433 16.9926 16.2134L17.8901 10.3801C18.1231 8.86571 16.9514 7.49996 15.4191 7.49996H12.4998C12.0396 7.49996 11.6665 7.12686 11.6665 6.66663V3.72149C11.6665 2.58662 10.7465 1.66663 9.61164 1.66663C9.34095 1.66663 9.09565 1.82604 8.98572 2.0734L6.05312 8.67174C5.91937 8.97268 5.62093 9.16663 5.29161 9.16663H3.33317C2.4127 9.16663 1.6665 9.91282 1.6665 10.8333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveThumsUp);
export default __webpack_public_path__ + "static/media/activeThumsUp.5db8e54b8fc84da816155cd92ede60ba.svg";
export { ForwardRef as ReactComponent };